/**
 * @ngdoc directive
 * @name cbl.insuranceloanpmi.mf.directive:creasValutazioneCerved
 * @restrict E
 * @description Componente che gestisce il primo sotto-step "Gestione Firmatari"
 *              dello step "Valutazione"
 */
(function() {
  'use strict';
  var CreasValutazioneCervedCtrl = function(
    $http,
    $scope,
    $state,
    $stateParams,
    $window,
    $q,
    $httpParamSerializer,
    CONSTANTS,
    labelSrvc,
    messaggiFctr,
    dettPraticaSrvc
  ) {
    this.$http = $http;
    this.$state = $state;
    this.$stateParams = $stateParams;
    this.$window = $window;
    this.messaggiFctr = messaggiFctr;
    this.dettPraticaSrvc = dettPraticaSrvc;
    this.CONSTANTS = CONSTANTS;
    $scope.msg = labelSrvc.getLabel;

    this.firmatariAttuali = null;
    this.nuovoFirmatario = null;
    
    this.isClienteCerved = false;
    
    this.valutazioneMerito = false;
    this.esitoValutazioneMerito = false;

    this.verificheAmministrative = false;
    this.verificheAmministrativePending = false;
    this.esitoVerificheAmministrative = false;

    // Spinner
    this.spinner = this.dettPraticaSrvc.spinner;
    this.subSpinner = {
      valutazione: false
    };

    // Configuro l'abilitazione dei pulsanti di scorrimento tra gli step
	dettPraticaSrvc.isCancelVisible = function() {
		return !(self.valutazioneMerito || self.verificheAmministrative);
	};
      
    dettPraticaSrvc.isCancelEnabled = function() {
      return true;
    };

    dettPraticaSrvc.isSaveEnabled = function() {
      return false;
    };

    dettPraticaSrvc.isPrevEnabled = function() {
      return true;
    };

    dettPraticaSrvc.isNextEnabled = function() {
      return self.esitoValutazioneMerito && self.esitoVerificheAmministrative;
    };

    var self = this;

    /**
	 * @ngdoc method
	 * @name promiseVerificaMeritoCreditizio
	 * @methodOf cbl.insuranceloanpmi.mf.directive:creasValutazioneCerved
	 * @description Effettua una chiamata http per eseguire la verifica del
	 *              merito creditizio ed ottenerne l'esito
	 * @return {Promise} - Ritorna una promise contenente l'esito della verifica
	 */
    this.promiseVerificaMeritoCreditizio = function(idPratica) {
      return this.$http({
        method: 'GET',
        url:
          CONSTANTS.REST_ROOT +
          CONSTANTS.REST.PRATICHE.DETTAGLIO +
          self.dettPraticaSrvc.datiPratica.idPratica +
          '/valutazione/meritoCreditizio'
      });
    };

    /**
	 * @ngdoc method
	 * @name promiseVerificheAmministrative
	 * @methodOf cbl.insuranceloanpmi.mf.directive:creasValutazioneCerved
	 * @description Effettua una chiamata http per avviare le verifiche
	 *              amministrative sulla pratica
	 * @return {Promise} - Ritorna una promise contenente l'esito o lo stato
	 *         della verifica
	 */
    this.promiseVerificheAmministrative = function(ndgNuovoFirmatario) {
    	
      var queryParamsObj = {};
      
      if (ndgNuovoFirmatario) {
    	  queryParamsObj.ndg = ndgNuovoFirmatario;
      }
    	
      return this.$http({
        method: 'GET',
        url:
          CONSTANTS.REST_ROOT +
          CONSTANTS.REST.PRATICHE.DETTAGLIO +
          self.dettPraticaSrvc.datiPratica.idPratica +
          '/valutazione/verificheAmministrative',
        params: queryParamsObj
      });
    };
    
    /**
	 * @ngdoc method
	 * @name recuperaDatiPratica
	 * @methodOf cbl.insuranceloanpmi.mf.directive:creasValutazioneCerved
	 * @description Recupera i dati della pratica corrente
	 */
    this.recuperaDatiPratica = function(keepSpinner) {
    	self.subSpinner.valutazione = true;
    	
    	$q
        .all({
          datiPratica: self.dettPraticaSrvc.promiseDatiPratica(self.dettPraticaSrvc.datiPratica.idPratica),
        })
        .then(
          function(response) {
            if (
              self.messaggiFctr.processaResponse(response.datiPratica)
            ) {
              self.dettPraticaSrvc.datiPratica = {};
              return;
            }
            
            self.firmatariAttuali = null;
        	self.nuovoFirmatario = null;
            self.dettPraticaSrvc.datiPratica = response.datiPratica.data.result;
            self.verificaInfoCerved();
          },
          function(reason) {
            self.messaggiFctr.processaResponse(reason.datiPratica);
            self.dettPraticaSrvc.datiPratica = {};
          }
        )
        .finally(function() {
        	if (keepSpinner !== true) {        		
        		self.subSpinner.valutazione = false;
        	}
        });
    }

    /**
	 * @ngdoc method
	 * @name verificaInfoCerved
	 * @methodOf cbl.insuranceloanpmi.mf.directive:creasValutazioneCerved
	 * @description Verifica gli esiti presenti sulla pratica per le verifiche
	 *              amministrative
	 */
    this.verificaInfoCerved = function() {
    	
    	self.isClienteCerved = self.dettPraticaSrvc.isClienteCerved();
    	
    	if (self.dettPraticaSrvc.datiPratica.infoCerved) {
    		
    		// Valutazione merito creditizio
    		
    		if (self.dettPraticaSrvc.datiPratica.infoCerved.scoreNegativo === undefined || self.dettPraticaSrvc.datiPratica.infoCerved.scoreNegativo === null) {
    			self.valutazioneMerito = false;
    			self.esitoValutazioneMerito = false;
    			
    			self.subSpinner.valutazione = false;
    		} else if (self.dettPraticaSrvc.datiPratica.infoCerved.scoreNegativo === 0) {
    			self.valutazioneMerito = true;
				self.esitoValutazioneMerito = false;
				
				self.subSpinner.valutazione = false;
    		} else if (self.dettPraticaSrvc.datiPratica.infoCerved.scoreCgsx === 0) {
    			self.valutazioneMerito = true;
				self.esitoValutazioneMerito = false;
				
				self.subSpinner.valutazione = false;
    		} else {
    			self.valutazioneMerito = true;
				self.esitoValutazioneMerito = true; 
				
				self.subSpinner.valutazione = false;
    		}
    		
    		if (self.dettPraticaSrvc.datiPratica.infoCerved.scoreNegativo === undefined || self.dettPraticaSrvc.datiPratica.infoCerved.scoreNegativo === null) {
    			self.verificheAmministrative = false;
				self.esitoVerificheAmministrative = false;
				
				self.subSpinner.valutazione = false;
    		} else if (self.isClienteCerved === false || /* Issue CAPMI-228 */ self.dettPraticaSrvc.datiPratica.intestatario.formaCostitutiva === 'IND') { 
    			//Forzatura per sbloccare il pulsante
    			self.verificheAmministrative = true;
				self.esitoVerificheAmministrative = true;
				self.subSpinner.valutazione = false;
    		} else if (self.dettPraticaSrvc.datiPratica.infoCerved.verificaFirma === undefined || self.dettPraticaSrvc.datiPratica.infoCerved.verificaFirma === null || self.dettPraticaSrvc.datiPratica.infoCerved.verificaFirma === -1) {
    			self.verificheAmministrative = true;
    			self.verificheAmministrativePending = true;
				self.esitoVerificheAmministrative = false;
				
				self.subSpinner.valutazione = false;
    		} else if(self.dettPraticaSrvc.datiPratica.infoCerved.verificaFirma === 0){
    			self.verificheAmministrative = true;
    			self.verificheAmministrativePending = false;
    			self.esitoVerificheAmministrative = false;
    			
    			self.getFirmatariCliente();
    		} else if(self.dettPraticaSrvc.datiPratica.infoCerved.verificaFirma === 1){
    			self.verificheAmministrative = true;
    			self.verificheAmministrativePending = false;
    			self.esitoVerificheAmministrative = true;
    			
    			self.subSpinner.valutazione = false;
    		}    		
    	}
    	
    }

    /**
	 * @ngdoc method
	 * @name eseguiValutazioni
	 * @methodOf cbl.insuranceloanpmi.mf.directive:creasValutazioneCerved
	 * @description Lancia l'esecuzione delle verifiche di merito creditizio e
	 *              amministrative e ne recupera l'esito
	 */
    this.eseguiValutazioni = function() {
    	self.subSpinner.valutazione = true;
    	
    	if (self.isClienteCerved === false || /* Issue CAPMI-228 */ self.dettPraticaSrvc.datiPratica.intestatario.formaCostitutiva === 'IND') {
    		self.eseguiVerificaMeritoCreditizio();
    		return;
    	}
    	
    	self.eseguiVerificaMeritoCreditizio(self.eseguiVerificheAmministrative);
    };
    
    /**
	 * @ngdoc method
	 * @name eseguiVerificaMeritoCreditizio
	 * @methodOf cbl.insuranceloanpmi.mf.directive:creasValutazioneCerved
	 * @description Lancia l'esecuzione della verifica di merito creditizio
	 */
    this.eseguiVerificaMeritoCreditizio = function(callOnSuccess) {
      self.subSpinner.valutazione = true;
      
      $q
        .all({
        	meritoCreditizio: self.promiseVerificaMeritoCreditizio(),
        })
        .then(
          function(response) {
            if (self.messaggiFctr.processaResponse(response.meritoCreditizio)) {
            	self.recuperaDatiPratica();
            	return;
            }
            
            if (typeof callOnSuccess === 'function') {
            	callOnSuccess();
            } else {            	
            	self.recuperaDatiPratica();
            }
            
          },
          function(reason) {
            self.messaggiFctr.processaResponse(reason.meritoCreditizio);
            self.recuperaDatiPratica();
          }
        )
        .finally(function() { });
    };

    /**
	 * @ngdoc method
	 * @name eseguiVerificheAmministrative
	 * @methodOf cbl.insuranceloanpmi.mf.directive:creasValutazioneCerved
	 * @description Lancia l'esecuzione o richiede lo stato delle sole verifiche
	 *              amministrative e ne recupera l'esito
	 */
    this.eseguiVerificheAmministrative = function() {
      self.subSpinner.valutazione = true;
      
      var ndgNuovoFirmatario = null;
      
      if (self.nuovoFirmatario) {
    	  ndgNuovoFirmatario = self.nuovoFirmatario.ndg;
      }
      
      $q
        .all({
          verificheAmministrative: self.promiseVerificheAmministrative(ndgNuovoFirmatario)
        })
        .then(
          function(response) {
            self.messaggiFctr.processaResponse(response.verificheAmministrative);       	            
          },
          function(reason) {
            self.messaggiFctr.processaResponse(reason.verificheAmministrative);
          }
        )
        .finally(function() {
          self.recuperaDatiPratica(true);
        });
    };
    
    /**
	 * @ngdoc method
	 * @name getFirmatariCliente
	 * @methodOf cbl.insuranceloanpmi.mf.directive:creasValutazioneCerved
	 * @description Recupera i firmatari del cliente
	 */ 
    this.getFirmatariCliente = function() {    	
		self.subSpinner.valutazione = true;
		$q
		.all({
			firmatariCliente: self.dettPraticaSrvc.promiseFirmatariCliente()
		})
		.then(
			function(response) {
				if (self.messaggiFctr.processaResponse(response.firmatariCliente) !== false) {
					self.subSpinner.valutazione = false;
					return;
				}
				
				self.dettPraticaSrvc.firmatariCliente = response.firmatariCliente.data.result;
				self.getFirmatariPratica();
			},
			function(reason) {
				self.dettPraticaSrvc.firmatariCliente = [];
				self.messaggiFctr.processaResponse(reason.firmatariCliente);
			}
		);
    };
    
    /**
	 * @ngdoc method
	 * @name getFirmatariPratica
	 * @methodOf cbl.insuranceloanpmi.mf.directive:creasValutazioneCerved
	 * @description Recupera i firmatari già valutati per la pratica
	 */ 
    this.getFirmatariPratica = function() {
		self.subSpinner.valutazione = true;
		$q
		.all({
			firmatariPratica: self.dettPraticaSrvc.promiseFirmatariVerificati()
		})
		.then(
			function(response) {
				if (self.messaggiFctr.processaResponse(response.firmatariPratica) !== false) {
					return;
				}
				
				self.firmatariAttuali = response.firmatariPratica.data.result;
			},
			function(reason) {
				self.dettPraticaSrvc.firmatariCliente = [];
				self.messaggiFctr.processaResponse(reason.firmatariPratica);
			}
		)
		.finally(
			function() {
				self.subSpinner.valutazione = false;
			}
		);
    };
    
    /**
	 * @ngdoc method
	 * @name isFirmatarioNonValido
	 * @methodOf cbl.insuranceloanpmi.mf.directive:creasValutazioneCerved
	 * @description Permette di verificare se il firmatario passato è o meno selezionabile per eseguire la valutazione
	 * @param {object} firmatario - L'oggetto firmatario da valutare
	 * @return {boolean} - Restituisce true se il firmatario non è selezionabile per la valutazione (ad esempio, è già stato valutato con esito negativo), o false se invece è selezionabile
	 */
    this.isFirmatarioNonValido = function(firmatario) {
    	if (self.firmatariAttuali && self.firmatariAttuali.length) {    		
    		for(var i = 0; i < self.firmatariAttuali.length; i++) {
    			if (self.firmatariAttuali[i].cfFirmatario.toUpperCase() === firmatario.codiceFiscale.toUpperCase() && self.firmatariAttuali[i].esito === 'KO') {
    				return true;
    			}
    		}
    	}
    	
    	return false;
    };
    
    // Carico i dati della pratica
    this.recuperaDatiPratica();
  };

  CreasValutazioneCervedCtrl.$inject = [
    '$http',
    '$scope',
    '$state',
    '$stateParams',
    '$window',
    '$q',
    '$httpParamSerializer',
    'CONSTANTS',
    'LabelSrvc',
    'CreasMessaggiFctr',
    'CreasDettaglioPraticaSrvc'
  ];

  var TemplateUrl = function(CONSTANTS) {
    return (
      CONSTANTS.BASE_ROOT +
      CONSTANTS.COMPONENTS_PATH +
      'creasDettaglioPratica/creasValutazionePratica/creasValutazioneCerved/creasValutazioneCerved.html'
    );
  };

  TemplateUrl.$inject = ['CONSTANTS'];

  var CreasValutazioneCervedComponent = {
    bindings: {},
    controller: CreasValutazioneCervedCtrl,
    controllerAs: 'creasValutazioneCervedCtrl',
    templateUrl: TemplateUrl
  };

  angular
    .module('cbl.insuranceloanpmi.mf')
    .component('creasValutazioneCerved', CreasValutazioneCervedComponent);
})();



//////////////////
// WEBPACK FOOTER
// ./app/components/creasDettaglioPratica/creasValutazionePratica/creasValutazioneCerved/creasValutazioneCerved.cmpt.js
// module id = 22
// module chunks = 0 1